// MUI
import { styled } from "@mui/system";

import Typography from "../MaterialKit/MKTypography";

const QuestionText = styled(Typography)(({ theme, large }) =>
  theme.unstable_sx({
    fontSize: large ? "12px" : "11px",
    [theme.breakpoints.up("sm")]: {
      fontSize: large ? "16px" : "14px",
    },

    [theme.breakpoints.up("md")]: {
      fontSize: large ? "20px" : "16px",
    },
  })
);

export default QuestionText;
